/* Public marketing video only. Entitlement and protected playback belong to a verified backend. */
(() => {
  if (window.__streamingThemeInstalled) return;
  window.__streamingThemeInstalled = true;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 767px)');
  const heroes = new Map();
  const trailers = new Map();
  let trailerPlaying = false;
  const cleanups = new Map();
  function cleanup(root) {
    for (const [element, dispose] of cleanups) {
      if (element === root || root.contains(element)) { dispose(); cleanups.delete(element); }
    }
  }
  function syncHeroes() { heroes.forEach(state => state.sync()); }
  function syncTrailers() {
    trailerPlaying = Array.from(trailers.values()).some(v => !v.paused && !v.ended);
    syncHeroes();
  }
  function init(root = document) {
    root.querySelectorAll('[data-sn-hero]').forEach(element => {
      if (heroes.has(element)) return;
      const video = element.querySelector('video');
      const button = element.querySelector('.sn-video-toggle');
      if (!video || !button) return;
      const abort = new AbortController();
      const options = { signal: abort.signal };
      let userPaused = false, failed = false, visible = true, selected = '', generation = 0;
      const updateButton = () => {
        button.hidden = motion.matches || failed || !selected;
        button.textContent = userPaused ? 'Play background' : 'Pause background';
        button.setAttribute('aria-label', userPaused ? 'Play background video' : 'Pause background video');
        button.setAttribute('aria-pressed', String(userPaused));
      };
      const state = { sync() {
        const desired = mobile.matches ? (video.dataset.mobile || video.dataset.desktop) : (video.dataset.desktop || video.dataset.mobile);
        if (motion.matches) {
          generation++; video.pause(); video.removeAttribute('src'); video.load(); selected = '';
          video.classList.remove('is-playing'); updateButton(); return;
        }
        if (desired !== selected) {
          generation++; video.pause(); video.classList.remove('is-playing'); selected = desired;
          failed = false;
          if (selected) { video.src = selected; video.muted = true; video.load(); }
        }
        updateButton();
        if (!selected || failed || userPaused || trailerPlaying || document.hidden || !visible) { generation++; video.pause(); return; }
        const attempt = ++generation;
        video.play().then(() => {
          if (attempt !== generation) return;
          if (motion.matches || trailerPlaying || userPaused || document.hidden || !visible) video.pause();
        }).catch(() => {
          if (attempt !== generation) return;
          failed = true; video.classList.remove('is-playing'); updateButton();
        });
      }};
      video.addEventListener('playing', () => video.classList.add('is-playing'), options);
      video.addEventListener('error', () => { failed = true; video.classList.remove('is-playing'); updateButton(); }, options);
      button.addEventListener('click', () => { userPaused = !userPaused; state.sync(); }, options);
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; state.sync(); });
      observer.observe(element);
      heroes.set(element, state);
      cleanups.set(element, () => { generation++; observer.disconnect(); abort.abort(); video.pause(); heroes.delete(element); });
      state.sync();
    });
    root.querySelectorAll('[data-sn-trailer]').forEach(element => {
      if (trailers.has(element)) return;
      const video = element.querySelector('video');
      const button = element.querySelector('.sn-trailer-start');
      if (!video || !button) return;
      const abort = new AbortController();
      const options = { signal: abort.signal };
      trailers.set(element, video);
      button.addEventListener('click', () => {
        video.hidden = false;
        video.controls = true;
        const cover = element.querySelector('.sn-trailer-cover');
        if (cover) cover.hidden = true;
        if (!video.dataset.loaded) {
          video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
          video.dataset.loaded = 'true'; video.load();
        }
        button.hidden = true;
        const close = element.querySelector('.sn-trailer-close');
        if (close) close.hidden = false;
        video.play().catch(() => { button.hidden = false; syncTrailers(); });
      }, options);
      const close = element.querySelector('.sn-trailer-close');
      if (close) close.addEventListener('click', () => {
        video.pause(); video.hidden = true; button.hidden = false; close.hidden = true;
        const cover = element.querySelector('.sn-trailer-cover');
        if (cover) cover.hidden = false;
        syncTrailers(); button.focus();
      }, options);
      video.addEventListener('play', () => { button.hidden = true; syncTrailers(); }, options);
      ['pause', 'ended', 'error'].forEach(event => video.addEventListener(event, syncTrailers, options));
      cleanups.set(element, () => { abort.abort(); video.pause(); trailers.delete(element); syncTrailers(); });
    });
  }
  document.addEventListener('click', event => {
    const trailerLink = event.target.closest('[data-sn-trailer-open]');
    if (trailerLink) {
      const section = document.querySelector('[data-sn-trailer]');
      const start = section && section.querySelector('.sn-trailer-start');
      if (start) { event.preventDefault(); section.scrollIntoView({behavior:motion.matches ? 'auto' : 'smooth'}); start.click(); } else { trailerLink.hash = 'trailer-play'; }
    }
    if (event.target.closest('.sn-mobile-menu a')) event.target.closest('details').open = false;
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.sn-mobile-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
  document.addEventListener('visibilitychange', syncHeroes);
  motion.addEventListener('change', syncHeroes);
  mobile.addEventListener('change', syncHeroes);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => cleanup(event.target));
  init();
  if (location.hash === '#trailer-play') {
    const section = document.querySelector('[data-sn-trailer]');
    if (section) {
      section.scrollIntoView({behavior:'auto'});
      const start = section.querySelector('.sn-trailer-start');
      if (start) start.click();
    }
  }
})();
